import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import { useAnalytics } from 'hooks/useAnalytics'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from 'state'
import { setSearchOpen } from 'state/app/actions'
import styled from 'styled-components'
import { Icons } from 'svgs'
import GameSearch from './GameSearch'
import { AppSearch } from './GameSearch/styled'

const StyledContainer = styled(Box)`
  height: ${({ theme }) => theme.topbarHeight};
  width: 100%;
`

const StyledAppSearch = styled(AppSearch)`
  max-width: 280px !important;
  background: ${({ theme }) => theme.colors.backgroundAlt5};
  border: none;
  display: none;
  backdrop-filter: blur(6px);

  ${({ theme }) => theme.mediaQueries.xl} {
    width: 100%;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    display: flex;
  }
`

const StyledSearchIconContainer = styled(Box)`
  border-radius: 50%;
  width: 44px;
  height: 44px;
  backdrop-filter: blur(15px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const TopbarContainer: React.FC<BoxProps> = ({ children, ...props }) => {
  return <StyledContainer {...props}>{children}</StyledContainer>
}

export const SearchView = () => {
  const isOpenSearch = useAppSelector((state) => state.app.isSearchOpen)
  const dispatch = useAppDispatch()

  const onCloseSearch = useCallback(() => {
    dispatch(setSearchOpen({ isOpen: false }))
  }, [])

  return isOpenSearch && <GameSearch onClose={onCloseSearch} />
}

export const SearchButtonIcon: React.FC<BoxProps & { SearchIcon?: React.ReactNode }> = ({
  SearchIcon = Icons.SearchIcon,
  ...props
}) => {
  const dispatch = useAppDispatch()
  const { addEventString } = useAnalytics()

  const openSearch = useCallback(() => {
    addEventString('[click][topbar][searchview]')
    dispatch(setSearchOpen({ isOpen: true }))
  }, [])

  return (
    <StyledSearchIconContainer onClick={openSearch} {...props}>
      <SearchIcon />
    </StyledSearchIconContainer>
  )
}

export const SearchInput = () => {
  const isOpenSearch = useAppSelector((state) => state.app.isSearchOpen)
  const dispatch = useAppDispatch()
  const { addEventString } = useAnalytics()
  const { t } = useTranslation()

  const openSearch = useCallback(() => {
    addEventString('[click][topbar][searchview]')
    dispatch(setSearchOpen({ isOpen: true }))
  }, [])

  return (
    <StyledAppSearch
      title="searchview-toggle"
      onFocus={openSearch}
      disabled={isOpenSearch}
      value={`${t('Search...')}`}
      hideAdornment
      id="searchview-toggle"
    />
  )
}
